import React, { useState, useEffect } from 'react';
import { List, Button, message, Modal, Card } from 'antd';
import axios from 'axios';
import { apiUrl } from './config';

const ClientListPage = () => {
    const [clients, setClients] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedClient, setSelectedClient] = useState(null); // Stato per il client selezionato

    // Mostra il modal e imposta il client selezionato
    const showModal = (client) => {
        setSelectedClient(client);
        setIsModalVisible(true);
    };

    // Funzione per revocare l'utenza
    const handleOk = async () => {
        if (selectedClient) {
            try {
                await axios.delete(`${apiUrl}/api/clients/${selectedClient._id}`);
                message.success('Utenza revocata con successo.');
                fetchClients(); // Aggiorna la lista dopo la revoca
            } catch (error) {
                message.error('Errore durante la revoca dell\'utenza.');
            } finally {
                setIsModalVisible(false);
                setSelectedClient(null);
            }
        }
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        setSelectedClient(null);
    };

    // Recupera la lista dei clienti
    const fetchClients = async () => {
        try {
            const response = await axios.get(`${apiUrl}/api/clients`);
            setClients(response.data);
        } catch (error) {
            message.error('Errore nel recupero della lista dei clienti.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchClients();
    }, []);

    return (
        <div>
            <h2>Lista Clienti</h2>
            <List
                dataSource={clients}
                loading={loading}
                renderItem={(client) => (
                    <Card style={{ marginBottom: '16px' }}>
                        <p><strong>Nome:</strong> {client.nome}</p>
                        <p><strong>Cognome:</strong> {client.cognome}</p>
                        <p><strong>Email:</strong> {client.email}</p>
                        <Button
                            style={{ backgroundColor: 'red', color: 'white' }}
                            onClick={() => showModal(client)} // Passa il client corrente
                        >
                            Revoca Utenza
                        </Button>
                    </Card>
                )}
                rowKey="_id"
            />
            <Modal
                title="Conferma Revoca Utenza"
                open={isModalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
                okText="Sì"
                cancelText="No"
                className="custom-modal"
            >
                <p>Sei sicuro di voler revocare l'utenza di questo cliente?</p>
            </Modal>
        </div>
    );
};

export default ClientListPage;
